
export const common = {
  languageSelector: {
    label: "Language", 
    hu: "Hungarian",
    en: "English",
    de: "German",
    pl: "Polish",
    cs: "Czech",
    es: "Spanish", 
    fr: "French",
    ro: "Romanian",
    nl: "Dutch",
    pt: "Portuguese",
    sv: "Swedish",
    da: "Danish",
    no: "Norwegian",
    fi: "Finnish",
    lt: "Lithuanian",
    bg: "Bulgarian",
    hr: "Croatian",
    at: "Austrian",
    it: "Italian"
  },
  buttons: {
    getStarted: "Get Started",
    learnMore: "Learn More",
    login: "Login"
  },
  terms: "Terms",
  aboutUs: "About Us",
  newsletter: "Newsletter",
  newsletterDescription: "Subscribe to our newsletter and be the first to know about new features!",
  emailPlaceholder: "Enter your email address",
  subscribe: "Subscribe",
  affiliateProgram: "Affiliate Program",
  copyright: "© 2025 Bespire. All rights reserved.",
  madeWithLove: "Made with ❤️ for creators",
  systemStatus: "System status: Online",
  termsOfService: "Terms of service coming soon!",
  logoAlt: "Bespire Logo"
};
